import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityFormProvider from '../entity-form-provider/entity-form-provider.vue';
import DisplayForm from '@shared/components/forms/auto-form/display-form/display-form.vue';
import FooterInfo from '@shared/components/forms/auto-form/footer-info/footer-info.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { ApiRouteType } from '@core/interfaces/core-services';
const AutoFormGroup = () =>
  import('@shared/components/forms/auto-form/auto-form-group/auto-form-group.vue');

@Component({
  name: 'bpc-std-form',
  components: {
    'bpc-auto-form-group': AutoFormGroup,
    'bpc-entity-form-provider': EntityFormProvider,
    'bpc-display-form': DisplayForm,
    'bpc-footer-info': FooterInfo,
  },
})
export default class StdForm<T = AnyEntity> extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof EntityFormProvider> & {
      disabled: boolean;
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      searchEntity(formModel: AnyEntity): void;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
      prepareToSave(entity: any): AnyEntity;
      fetchEntityAndConfig(): void;
    };
    autoFormGroup: InstanceType<any> & {
      onDeleteMediaFile(): void;
    };
  };

  @Prop(String) readonly entity: string;
  @Prop(String) readonly permissionEntityName: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: Object, default: null }) readonly presetDataToInitialize: AnyEntity;
  @Prop(String) readonly mode: string;
  @Prop([String, Object, Array]) readonly extraData: string | AnyEntity;
  @Prop({ type: Boolean, default: true }) readonly fetchEntity: boolean;
  @Prop(String) readonly fetchPath: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' }) readonly formConfigName: string;
  @Prop(String) readonly configFileName: string;
  @Prop({ type: String, default: null }) readonly savePath: string;
  @Prop({ type: String, default: null }) readonly configPath: string;
  @Prop({ type: String, default: null }) readonly apiRouteType: ApiRouteType;

  @Prop({ type: String, default: 'global.generic.successful_action' })
  readonly createdSuccessText: string;
  @Prop({ type: String, default: 'global.generic.successful_action' })
  readonly updatedSuccessText: string;
  @Prop({
    type: Function,
    default: (entityCopy: T): T => {
      return entityCopy;
    },
  })
  readonly actionBeforePrepareToSave: (entityCopy: T) => T;
  @Prop({
    type: Function,
    default: (entityCopy: T): T => {
      return entityCopy;
    },
  })
  readonly actionAfterPrepareToSave: (entityCopy: T) => T;

  public formModel: AnyEntity = {};

  public showMore: boolean = false;

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
  }

  onEntityErrorSaving(e) {
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }
  onValidationErrorsChanged(errorsObject) {
    this.$emit('validation-errors-cahnged', errorsObject);
  }

  async saveEntity(): Promise<BPCGenericApiResponse> {
    return await this.$refs.formProvider.saveEntity(this.formModel);
  }

  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  onEntitySearched(e) {
    this.formModel.action = 'search';
    this.$emit('entity-searched', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$nextTick().then(() => {
      this.formModel = event;
      this.$emit('model-loaded', event);
    });
  }
  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  searchEntity(): void {
    this.$refs.formProvider.searchEntity(this.formModel);
  }

  emitInputCustomEvent($event) {
    this.$emit('input-custom-event', $event);
  }

  public fetchEntityAndConfig() {
    this.$refs.formProvider.fetchEntityAndConfig();
  }

  public onDeleteMediaFile() {
    // TODO: Implement with Vuex because we need to refresh the form that start the action.
    // this.formModel.resources = null;
    // this.$refs.autoFormGroup.onDeleteMediaFile();
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }

  get disabledForm() {
    return this.$refs.formProvider.disabled || this.disabled;
  }

  get totalErrors() {
    return Object.entries(this.$refs.formProvider.errorsObject).filter(
      field => field[1].error !== null,
    ).length;
  }

  resetErrorObject() {
    this.$refs.formProvider.resetErrorObject();
  }

  manageSaveErrors(error) {
    this.$refs.formProvider.manageSaveErrors(error);
  }

  prepareToSave(entity: any): AnyEntity {
    return this.$refs.formProvider.prepareToSave(entity);
  }

  get errorsObject(): object {
    return this.$refs.formProvider?.errorsObject;
  }
}
